import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import DOMPurify from 'dompurify';

import htmx from 'htmx.org';

import '@/events';

import { initPageComponent, initSharedComponents, initAnalytics } from './load_components';

async function init() {
    window.Alpine = Alpine;
    window.htmx = htmx;
    window.DOMPurify = DOMPurify; // TODO: remove once DOMPurify is used only in modules

    await initSharedComponents();
    await initPageComponent();
    await initAnalytics();

    Alpine.plugin(intersect);
    Alpine.plugin(collapse);
    Alpine.start();
}

init();
